import React from 'react';
import cx from 'clsx';
import {
  Box,
  Button,
  Grid,
  GridSize,
  makeStyles,
  Paper,
  SvgIconProps,
  Typography
} from '@material-ui/core';
import { BuildAssessmentTypes } from '../keyboarding-report-types';

type Props = {
  title?: string;
  Icon: (props: SvgIconProps) => JSX.Element;
  data: BuildAssessmentTypes[];
  xs?: GridSize;
  style?: React.CSSProperties;
  onClick?: (data?: any) => void;
};

const DownloadListCard: React.FC<Props> = ({ title, onClick, Icon, data, xs, style }) => {
  const classes = useStyles();

  const getTitle = (x: BuildAssessmentTypes) => {
    return `View ${x.a1_question || x.a2_question}`;
  };

  return (
    <Paper variant="outlined" className={cx(classes.downloads, classes.noPrint)} style={style}>
      <Typography className={classes.title}>{title}</Typography>
      <Box display="flex" flex={1}>
        <Grid container xs={12}>
          <Grid container xs={xs} spacing={2}>
            {data.map((x, idx) => (
              <Grid
                xs={4}
                direction="column"
                key={`list_card_${idx}`}
                style={{ maxWidth: '100%', flexBasis: 300 }}
              >
                <Button
                  style={{ display: 'flex', flexFlow: 'wrap' }}
                  variant="text"
                  onClick={() => onClick?.(x)}
                >
                  <Icon style={{ color: '#005793' }} />
                  <Typography style={{ color: '#005793', fontWeight: 450 }} variant="subtitle2">
                    {getTitle(x)}
                  </Typography>
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  downloads: {
    display: 'flex',
    backgroundColor: '#F8F8F8',
    padding: 16,
    flexDirection: 'column'
  },
  title: {
    display: 'flex',
    flex: 1,
    marginBottom: 8
  },
  noPrint: {
    '@media print': { display: 'none' }
  }
}));
export default DownloadListCard;
